import { AnswerSelectContainerProps } from '../config';
import { FC } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../../../hooks/useStores';

const _ContainWpoTopics: FC<AnswerSelectContainerProps> = ({
  question,
  onPress,
  children,
}) => {

  const { language } = useStores();
  const labels = language?.translate?.MOBILE?.ASSISTANCE?.WPO?.TOPICS;
  const answers = question.answers?.map(answer => ({
    ...answer,
    wording: labels &&
      answer.wording &&
      labels[answer.wording]
      ? labels[answer.wording]
      : answer.wording || ''
  }));

  return children({
    answers: answers || [],
    questionId: question._id,
    questionKey: question.key,
    onPress,
  });
};


export const ContainWpoTopics = observer(_ContainWpoTopics);
